/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Loop_5_TitleInputs */

const en_mk_loop_5_title = /** @type {(inputs: Mk_Loop_5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The server gate`)
};

const id_mk_loop_5_title = /** @type {(inputs: Mk_Loop_5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerbang server`)
};

/**
* | output |
* | --- |
* | "The server gate" |
*
* @param {Mk_Loop_5_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_loop_5_title = /** @type {((inputs?: Mk_Loop_5_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Loop_5_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_loop_5_title(inputs)
	return en_mk_loop_5_title(inputs)
});